export default {
  setInvoices: (state, invoices) => {
    state.invoices = invoices;
  },

  setInvoicesFilter: (state, invoicesFilter) => {
    state.invoicesFilter = invoicesFilter;
  },

  setCurrentInvoice: (state, invoice) => {
    state.currentInvoice = invoice;
  },

  setInvoiceTypes: (state, statuses) => {
    state.invoiceTypes = statuses;
  },

  setInvoiceStatuses: (state, statuses) => {
    state.invoiceStatuses = statuses;
  },

  setInvoiceMassStatuses: (state, statuses) => {
    state.invoiceMassStatuses = statuses;
  },

  updateInvoice: (state, invoice) => {
    state.invoices = state.invoices.map(item => {
      if (item.id === invoice.id) {
        return Object.assign({}, item, invoice);
      }

      return item;
    });
  },

  setInvoicesErrors: (state, errors) => {
    state.invoicesErrors = errors;
  },

  clearInvoicesErrors: state => {
    state.invoicesErrors = [];
  },

  updateInvoicesStatuses: (state, { ids, status }) => {
    state.invoices = state.invoices.map(item => {
      if (ids.includes(item.id)) {
        return Object.assign({}, item, {
          status: status.name,
          status_id: status.id
        });
      }

      return item;
    });
  },

  setPayrolls: (state, payrolls) => {
    state.payrolls = payrolls;
  },

  setPayrollsFilter: (state, payrollsFilter) => {
    state.payrollsFilter = payrollsFilter;
  },

  setCurrentPayroll: (state, payroll) => {
    state.currentPayroll = payroll;
  },

  setPayrollStatuses: (state, statuses) => {
    state.payrollStatuses = statuses;
  },

  setPayrollMassStatuses: (state, statuses) => {
    state.payrollMassStatuses = statuses;
  },

  updatePayroll: (state, payroll) => {
    state.payrolls = state.payrolls.map(item => {
      if (item.id === payroll.id) {
        return Object.assign({}, item, payroll);
      }

      return item;
    });
  },

  updatePayrollsStatuses: (state, { ids, status }) => {
    state.payrolls = state.payrolls.map(item => {
      if (ids.includes(item.id)) {
        return Object.assign({}, item, {
          status: status.name,
          status_id: status.id
        });
      }

      return item;
    });
  },

  setExpenses: (state, expenses) => {
    state.expenses = expenses;
  },

  setExpensesFilter: (state, expensesFilter) => {
    state.expensesFilter = expensesFilter;
  },

  setCurrentAmount: (state, amount) => {
    state.currentAmount = amount;
  },

  setCurrentExpense: (state, expense) => {
    state.currentExpense = expense;
  },

  setAccountParams: (state, accountParams) => {
    state.accountParams = accountParams;
  },

  updateExpensesStatuses: (state, { ids, status }) => {
    state.expenses = state.expenses.map(item => {
      if (ids.includes(item.id)) {
        return Object.assign({}, item, {
          status: status.name,
          status_id: status.id
        });
      }

      return item;
    });
  },

  setEreporterChip: (state, ereporterChip) => {
    state.ereporterChip = ereporterChip;
  }
};
